/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

// Vibration feedback through the Vibration API (Android Chrome/Firefox; iOS
// Safari has no equivalent, so there it is silently a no-op).

const KEY = "nyrvex-hub-haptics";

export const hapticsSupported = (): boolean => typeof navigator !== "undefined" && "vibrate" in navigator;

export function hapticsEnabled(): boolean {
  try {
    return localStorage.getItem(KEY) !== "off";
  } catch {
    return true;
  }
}

export function setHaptics(on: boolean): void {
  try {
    localStorage.setItem(KEY, on ? "on" : "off");
  } catch {
    /* ignore */
  }
  if (on) buzz(30, true);
}

/** Vibrate for `pattern` ms; `force` skips the on/off setting (used by the toggle's own confirmation). */
export function buzz(pattern: number | readonly number[], force = false): boolean {
  if (!hapticsSupported() || (!force && !hapticsEnabled())) return false;
  try {
    return navigator.vibrate(pattern as number | number[]);
  } catch {
    return false; /* blocked until the user has interacted with the page */
  }
}

export const HAPTIC = {
  tap: 12,
  ok: [18, 40, 18],
  fail: [60, 50, 60],
  info: [30],
  warn: [90, 70, 90],
  crit: [220, 90, 220, 90, 220],
} as const;
